/* ad-past-pieces.js — Past Pieces showcase slideshow (vanilla, no framework dependency) */
(function () {
  function initPP(root) {
    var slides = [].slice.call(root.querySelectorAll('.ad-pp__slide'));
    var dots   = [].slice.call(root.querySelectorAll('.ad-pp__dot'));
    var counter = root.querySelector('.ad-pp__counter');
    var n = slides.length;
    if (!n) return;
    var i = 0, ms = parseInt(root.getAttribute('data-autoplay'), 10) || 0, timer = null;

    function render() {
      for (var k = 0; k < n; k++) slides[k].classList.toggle('is-active', k === i);
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === i);
        dots[d].setAttribute('aria-selected', d === i ? 'true' : 'false');
      }
      if (counter) counter.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + n).slice(-2);
    }
    function go(k) { i = ((k % n) + n) % n; render(); restart(); }
    function next() { go(i + 1); }
    function prev() { go(i - 1); }
    function restart() { if (timer) { clearInterval(timer); timer = null; } if (ms > 0 && n > 1) timer = setInterval(next, ms); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    [].forEach.call(root.querySelectorAll('[data-dir="next"]'), function (b) { b.addEventListener('click', next); });
    [].forEach.call(root.querySelectorAll('[data-dir="prev"]'), function (b) { b.addEventListener('click', prev); });
    for (var q = 0; q < dots.length; q++) (function (k) { dots[k].addEventListener('click', function () { go(k); }); })(q);
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', restart);
    root.addEventListener('focusin', stop);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (!e.isIntersecting) stop(); else restart(); });
      }, { threshold: 0 }).observe(root);
    }
    render(); restart();
  }
  function boot() { [].forEach.call(document.querySelectorAll('.ad-pp'), initPP); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
